import { render, staticRenderFns } from "./DrawInput.vue?vue&type=template&id=1ae5d551&scoped=true&"
import script from "./DrawInput.vue?vue&type=script&lang=js&"
export * from "./DrawInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae5d551",
  null
  
)

export default component.exports